import { Bot } from "lucide-react";

function formatTime(date) {
  return new Intl.DateTimeFormat("fa-IR", { hour: "2-digit", minute: "2-digit" }).format(date);
}

export default function ChatMessage({ message, userInitial }) {
  const isAgent = message.role === "agent";

  return (
    <div className={`msg${isAgent ? " msg-agent" : " msg-user"}`}>
      <span className="msg-avatar" aria-hidden="true">
        {isAgent ? <Bot size={18} strokeWidth={1.9} /> : userInitial}
      </span>
      <div className="msg-body">
        <div className="msg-meta">
          <strong>{isAgent ? "ایجنت" : "شما"}</strong>
          <span>{formatTime(message.at)}</span>
        </div>
        <div className="msg-bubble">{message.content}</div>
      </div>
    </div>
  );
}
